import { ItemVersaoRangeSelecao } from "./ItemVersaoRangeSelecao";

export class RangeSelecao {
  inicio: number;
  termino: number;
  idItens: Array<ItemVersaoRangeSelecao>;
}
